export const defaultProposalTitle = 'Inbox Design Proposal';